<template>
  <div class="lab-media-assessed-check">
    <md-chip class="md-primary">Was {{ 'Media' | translateFeatureLabel }}</md-chip>
    <md-field>
      <md-select
        v-close-on-zoom
        :value="state.check.url"
        :placeholder="'File'"
        class="media-select"
        :disabled="readonly"
        :md-attach-to-parent="true"
        @input="selectLabAssetFile"
      >
        <md-option :key="'*clear*'">Clear selection</md-option>
        <md-optgroup
          v-for="labAsset in imageLabAssets"
          :key="labAsset.id"
          :label="labAsset.name.en"
        >
          <md-option
            v-for="file in getFilesFor(labAsset)"
            :key="file.url"
            :value="file.url"
          >
            {{ file.name }}
          </md-option>
        </md-optgroup>
      </md-select>
    </md-field>
    <help-tooltip v-if="errors && errors.length" type="error">
      <span v-for="error in errors" :key="error.message">{{ error.message }}</span>
    </help-tooltip>
    <md-chip class="md-primary">viewed ?</md-chip>
  </div>
</template>

<script>
import flatten from 'lodash/flatten';
import fromPairs from 'lodash/fromPairs';
import get from 'lodash/get';
import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'lab-media-assessed-check',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'type',
    'labAssets',
  ],
  data() {
    return {
      state: {
        check: {
          id: null,
          url: null,
        },
      },
    };
  },
  computed: {
    imageLabAssets() {
      return this.labAssets.filter(
        labAsset =>
          (labAsset.type === 'image' || labAsset.type === 'namedImage') &&
          this.getFilesFor(labAsset).length > 0,
      );
    },
    labAssetKeysByFileUrl() {
      return fromPairs(
        flatten(
          this.emitter.caseConf._labAssets.map(labAsset => {
            if (!labAsset.options || !labAsset.options.assets) {
              return [];
            }
            return labAsset.options.assets.map(asset => [
              asset.url,
              labAsset.key,
            ]);
          }),
        ),
      );
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      return get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
      );
    },
  },
  mounted() {
    this.state.check = this.getData(this.ikey) || this.state.check;
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectLabAssetFile(url) {
      if (url) {
        const labAssetKey = this.labAssetKeysByFileUrl[url];
        if (labAssetKey) {
          this.state.check.id = labAssetKey;
          this.state.check.url = url;
        }
      } else {
        this.state.check.id = undefined;
        this.state.check.url = undefined;
      }
      this.update();
    },
    getFilesFor(labAsset) {
      const { _labAssets } = this.emitter.caseConf;
      if (!_labAssets) {
        return [];
      }
      const caseLabAsset = _labAssets.find(asset => asset.id === labAsset.id);
      if (!caseLabAsset) {
        return [];
      }
      return caseLabAsset.options.assets;
    },
    update() {
      this.putData(this.ikey, {
        ...this.state.check,
        type: 'LAB_ASSET_VIEWED',
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.lab-media-assessed-check {
  display: flex;
  align-items: center;
}
</style>
